import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, inject, input, OnInit } from '@angular/core';

import { EnvUtils } from '@ecm/dispatcher';
import { EcmMaterialModule } from '@ecm/material';
import { CappingData, LinkService, TmsData, TrackingData } from '@ecm/router';

import { DashboardHelpsViewModel } from '../../../business/model/home/dashboard/dashboard-helps.view-model';
import { TrackedPage } from '../../../business/model/tracking/trackedPage.enum';
import { TrackingService } from '../../../services/tracking.service';
import { ImageUtils } from '../../../utils/image.utils';
import { AdviseWhitelistEclairConstants } from '../../shared/advise-whitelist-eclair.constants';

@Component({
    selector: 'push-helps[infos]',
    templateUrl: './push-helps.component.html',
    styleUrls: ['./push-helps.component.css'],
    standalone: true,
    imports: [NgTemplateOutlet, EcmMaterialModule, NgClass],
})
export class PushHelpsComponent implements OnInit {
    public infos = input<DashboardHelpsViewModel[]>();
    public isMobile = input<boolean>();
    public isSoshBrand = input<boolean>();

    protected readonly AdviseWhitelistEclairConstants = AdviseWhitelistEclairConstants;
    public zid!: string;
    public isEclair!: boolean;

    private readonly linkService = inject(LinkService);
    private readonly trackingService = inject(TrackingService);

    public ngOnInit(): void {
        this.isEclair = EnvUtils.isEclair();
        if (this.infos()) {
            for (const info of this.infos()) {
                if (info.link) {
                    info.href = this.linkService.getLinkSync(info.link);
                }
                this.zid = this.trackingService.getTrackNamePerType(info.type, this.isMobile(), this.isSoshBrand());
            }
        }
    }

    public openLink(info: DashboardHelpsViewModel) {
        const trackingData = new TmsData({
            trackedPage: TrackedPage.dashboard,
            trackingArea: 'care_hp_top_helping',
            trackingName: info.code,
            additionalProperties: new Map<string, string>().set('track_type_evt', 'select_content'),
        });

        this.linkService.openLink(
            info.link,
            new TrackingData({
                cappingTracking:
                    info.advTracker && info.advTracker.length > 0
                        ? new CappingData({
                              advTracker: info.advTracker,
                              code: info.code,
                              cid: info.cid,
                          })
                        : undefined,
                tmsTracking: trackingData,
            }),
        );
    }

    public getImgFormat(imgurl: string) {
        return ImageUtils.transformUrl(imgurl, '32');
    }
}
